import gql from 'graphql-tag';

export const GET_PHOTOBOOTH_CONTENT = gql`
  query getPhotobooth($id: ID!) {
    photobooth(id: $id)
  }
`;
